import React, { useState, useEffect } from 'react';
import { useI18n } from '../App';

const NAV_LINKS = [
  { key:'about',       href:'#about'       },
  { key:'services',    href:'#services'    },
  { key:'hosting',     href:'#hosting'     },
  { key:'development', href:'#development' },
  { key:'domain',      href:'#domain'      },
  { key:'faq',         href:'#faq'         },
];

export default function Header() {
  const { t, lang, isRTL, toggleLang } = useI18n();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn, { passive:true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <>
      <header
        role="banner"
        style={{
          background:     scrolled ? 'rgba(13,15,20,0.93)' : 'rgba(13,15,20,0.6)',
          backdropFilter: 'blur(20px)',
          borderBottom:   '1px solid rgba(255,255,255,0.07)',
          position:       'sticky',
          top: 0, zIndex: 100,
          transition:     'background 0.35s ease',
        }}
      >
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-6"
          style={{ height:66, padding:'0 clamp(16px,5vw,80px)' }}>

          {/* Logo */}
          <a href="#hero" aria-label="Sityx — الرئيسية"
            className="gradient-text-brand font-display font-bold text-2xl tracking-tight select-none"
            style={{ textDecoration:'none' }}>
            sityx
          </a>

          {/* Desktop nav */}
          <nav role="navigation" aria-label="Main navigation"
            className="hidden md:flex items-center gap-1">
            {NAV_LINKS.map(({ key, href }) => (
              <a key={key} href={href}
                className="text-sm font-normal px-3 py-2 rounded-lg transition-colors duration-200"
                style={{ color:'var(--muted)' }}
                onMouseEnter={e=>{ e.currentTarget.style.color='var(--text)'; e.currentTarget.style.background='var(--surface)'; }}
                onMouseLeave={e=>{ e.currentTarget.style.color='var(--muted)'; e.currentTarget.style.background='transparent'; }}
              >
                {t.nav[key]}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            {/* Lang toggle */}
            <button onClick={toggleLang} aria-label="Switch language"
              className="flex items-center gap-2 text-xs font-medium tracking-widest px-3 py-2 rounded-xl border transition-all duration-200"
              style={{ background:'var(--surface)', borderColor:'var(--border)', color:'var(--muted)' }}
              onMouseEnter={e=>{ e.currentTarget.style.color='var(--accent-cyan)'; e.currentTarget.style.borderColor='var(--accent-cyan)'; }}
              onMouseLeave={e=>{ e.currentTarget.style.color='var(--muted)'; e.currentTarget.style.borderColor='var(--border)'; }}
            >
              🌐 {lang === 'en' ? 'AR' : 'EN'}
            </button>

            {/* CTA */}
            <a href="https://wa.me/963983566739" target="_blank" rel="noopener noreferrer"
              className="hidden md:inline-flex items-center gap-2 text-sm font-medium px-5 py-2 rounded-xl transition-all duration-200 hover:opacity-90 hover:-translate-y-px"
              style={{ background:'linear-gradient(135deg,var(--accent-cyan),var(--accent-purple))', color:'#000' }}>
              {t.nav.contact}
            </a>

            {/* Hamburger */}
            <button className="md:hidden flex flex-col gap-[5px] p-2" aria-label="Toggle menu"
              onClick={() => setMenuOpen(v => !v)}>
              {[0,1,2].map(i => (
                <span key={i} className="block w-[22px] h-[2px] rounded-full transition-all duration-300"
                  style={{ background:'var(--text)',
                    transform: menuOpen && i===0 ? 'translateY(7px) rotate(45deg)'
                              : menuOpen && i===2 ? 'translateY(-7px) rotate(-45deg)'
                              : menuOpen && i===1 ? 'scaleX(0)' : 'none' }} />
              ))}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile drawer */}
      {menuOpen && (
        <div role="dialog" aria-modal="true" aria-label="Mobile navigation"
          className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-3 px-6 md:hidden"
          style={{ background:'rgba(13,15,20,0.97)', backdropFilter:'blur(20px)', top:66, animation:'fadeUp 0.3s ease both' }}>
          {NAV_LINKS.map(({ key, href }) => (
            <a key={key} href={href} onClick={() => setMenuOpen(false)}
              className="w-full max-w-xs text-center text-lg font-normal py-4 rounded-2xl transition-colors duration-200"
              style={{ color:'var(--muted)' }}
              onMouseEnter={e=>{ e.currentTarget.style.color='var(--text)'; e.currentTarget.style.background='var(--surface)'; }}
              onMouseLeave={e=>{ e.currentTarget.style.color='var(--muted)'; e.currentTarget.style.background='transparent'; }}>
              {t.nav[key]}
            </a>
          ))}
          <a href="https://wa.me/963983566739" target="_blank" rel="noopener noreferrer"
            onClick={() => setMenuOpen(false)}
            className="mt-4 w-full max-w-xs py-4 rounded-2xl font-medium text-sm text-center"
            style={{ background:'linear-gradient(135deg,var(--accent-cyan),var(--accent-purple))', color:'#000' }}>
            {t.nav.contact}
          </a>
        </div>
      )}
    </>
  );
}
